import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sumBy from "lodash/sumBy";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { SAMPLES_ERROR, SAMPLES_SAVING, SAMPLES_VALUE_IN_METADATA_TRACK_UPDATED } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { loadBackendStatus } from 'redux/actions/backendStatus';
var updateValuesInMetadataTrack = function updateValuesInMetadataTrack(experimentId, metadataTrackKey, updates) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_sumBy(updates, function (_ref2) {
              var sampleIds = _ref2.sampleIds;
              return sampleIds.length;
            }) === 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            dispatch({
              type: SAMPLES_SAVING,
              payload: {
                message: endUserMessages.SAVING_SAMPLE
              }
            });
            _context.prev = 3;
            _context.next = 6;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/metadataTracks/").concat(metadataTrackKey), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
            });
          case 6:
            dispatch({
              type: SAMPLES_VALUE_IN_METADATA_TRACK_UPDATED,
              payload: {
                key: metadataTrackKey,
                updates: updates
              }
            });
            _context.next = 9;
            return dispatch(loadBackendStatus(experimentId));
          case 9:
            _context.next = 16;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_SAVING);
            dispatch({
              type: SAMPLES_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateValuesInMetadataTrack;